import React, { useState } from 'react'
import { RiMenu3Fill, RiCloseFill } from 'react-icons/ri';
import {Link} from 'react-router-dom';
function Header() {
    const [showHeader, setShowHeader] = useState(false)
    const path = window.location.pathname

    return (
        <div>
            {showHeader ? (<RiCloseFill onClick={() => { setShowHeader(!showHeader) }} className='position-fixed top-0 end-0 menu-icon' />)
                : (<RiMenu3Fill onClick={() => { setShowHeader(!showHeader) }} className='position-fixed top-0 end-0 menu-icon' />)}
                

            <ul className = {`${showHeader? 'show-header n-box1' :'hide-header n-box1'}`}>
                <li className = {`${path==='/' && 'active'}`}><Link to = '/'>Home</Link></li>
                <li className = {`${path==='/projects'&&'active'}`}><Link to = '/projects'>Projects</Link></li>
                <li className = {`${path==='/courses'&&'active'}`}><Link to = '/courses'>Courses</Link></li>
                <li className = {`${path==='/contact'&&'active'}`}><Link to = '/contact'>Contact</Link></li>

            </ul>



        </div>
    )
}

export default Header
